import React, { Component } from 'react';
import { Modal, Button, Radio, message } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import API_URL from '../../../common/url';
import Text from '../../basicElement/Text';
import ContentList from '../../basicElement/ContentList';

const RadioGroup = Radio.Group;

const defaultList = [
    { label: '是', value: '1' },
    { label: '否', value: '0' },
];

class AddTeamLeaderUnit extends Component {
    state = {
        visible: false,
        params: {},
        data: [],
    }

    show = (data) => {
        this.setState({
            data: data || [],
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            params: {},
            data: [],
        });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        switch (key) {
            case 'hospital': {
                const { value: id, text: name, postCode } = value;
                params[`${key}Id`] = id;
                params[`${key}Name`] = name;
                params.postCode = postCode;
                break;
            }
            default:
                params[key] = value;
        }
        this.setState({ params });
    }

    handleAdd = () => {
        const { params, data } = this.state;
        const { hospitalId, hospitalName, isReportUnit, postCode } = params;
        let msg;
        switch(true) {
            case !hospitalId:
                msg = '请选择组长单位';
                break;
            case !!hospitalId && data.some(i => i.hospitalId == hospitalId):
                msg = '医疗机构(组长单位)不能重复添加';
                break;
            case !isReportUnit:
                msg = '请选择本中心是否遗传办申报单位';
                break;
            case !postCode:
                msg = `医疗机构（组长单位）${hospitalName}未填写邮编，请补充后添加`;
                break;
        }
        if (msg) {
            message.warning(msg);
            return;
        }

        data.push({...params});
        this.setState({
            data,
            params: {},
        });
    }

    handleRemove = (index) => {
        const { data } = this.state;
        data.splice(index, 1);
        this.setState({ data });
    }

    confirm = () => {
        this.props.onChange(this.state.data, 'teamLeaderList');
        this.hide();
    }

    render() {
        const { visible, params, data } = this.state;
        const defaultOption = defaultList.map(i => <Radio value={i.value}>{i.label}</Radio>);
        return (
            <Modal
                title="添加医疗机构（组长单位）"
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="preview-modal"
                width="550px"
            >
                <div className="field">
                    <div className="field-form">
                        <div className="field-list">
                            <div className="field-item">
                                <span className="field-label"><Text asterisk={true} colon={true}>医疗机构（组长单位）</Text></span>
                                <div className="field-value">
                                    <SearchRetrieve
                                        keyword='hospitalName'
                                        style={{ width: '100%' }}
                                        placeholder="输入名称检索"
                                        value={params.hospitalName}
                                        params={{ limit: 20 }}
                                        url={API_URL.invStartUp.queryHospitalListByInve}
                                        config={{ id: 'hospitalId', name: 'hospitalName' }}
                                        onChange={value => this.handleChange(value, 'hospital')}
                                    />
                                </div>
                            </div>
                            <div className="field-item">
                                <span className="field-label"><Text asterisk={true} colon={true}>本中心是否遗传办申报单位</Text></span>
                                <div className="field-value">
                                    <RadioGroup onChange={e => this.handleChange(e.target.value, 'isReportUnit')} value={params.isReportUnit}>
                                        { defaultOption }
                                    </RadioGroup>
                                </div>
                            </div>
                        </div>
                        <div  className="field-button">
                            <Button type="primary" onClick={this.handleAdd}>添加</Button>
                        </div>
                    </div>
                    <ContentList
                        data={data}
                        onRemove={this.handleRemove}
                        render={item => {
                            const { hospitalName, isReportUnit } = item;
                            return `${hospitalName}${isReportUnit == 1 ? '(申报单位)' : ''}`;
                        }}
                    />
                </div>
            </Modal>
        );
    }
}

export default AddTeamLeaderUnit;


// WEBPACK FOOTER //
// ./src/components/invStartUp/heredity/AddTeamLeaderUnit.js